// <delivery-estimate>: replaces the business-day range with real dates, counting Monday to Friday from today.
if (!customElements.get('delivery-estimate')) {
  customElements.define(
    'delivery-estimate',
    class DeliveryEstimate extends HTMLElement {
      connectedCallback() {
        const min = parseInt(this.dataset.minDays, 10);
        const max = parseInt(this.dataset.maxDays, 10);
        const template = this.dataset.template;
        if (!min || !max || !template) return;

        const format = new Intl.DateTimeFormat(this.dataset.locale || document.documentElement.lang || 'es', {
          day: 'numeric',
          month: 'long',
        });

        this.textContent = template
          .replace('[start]', format.format(this.addBusinessDays(new Date(), min)))
          .replace('[end]', format.format(this.addBusinessDays(new Date(), max)));
      }

      addBusinessDays(date, days) {
        const result = new Date(date);
        let added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          const day = result.getDay();
          if (day !== 0 && day !== 6) added += 1;
        }
        return result;
      }
    }
  );
}
